import { getSortedModules } from "./index100.js";
import { getModuleSizeZ } from "./index106.js";
import { isInRange } from "@project-rouge/rg-core";
function tryInsertionMethod(space, apartmentIndex, moduleIndex, apartmentArray, method) {
	if (apartmentIndex >= apartmentArray.length) return {
		success: false,
		outOfBounds: "PosJ"
	};
	let total = 0;
	const threshold = method === "Area" ? space.area[0] : space.sizeX[0];
	const modules = [];
	let currentModules;
	let sizeX = 0;
	let sizeY = Infinity;
	let sizeZ = 0;
	while (total < threshold) {
		if (apartmentIndex >= apartmentArray.length) return {
			success: false,
			outOfBounds: "PosJ"
		};
		currentModules = getSortedModules(apartmentArray, apartmentIndex);
		modules.push(currentModules[moduleIndex]);
		const x = currentModules[moduleIndex].size[0];
		sizeX += x;
		const y = currentModules[moduleIndex].size[1];
		sizeY = Math.min(sizeY, y);
		const z = getModuleSizeZ(currentModules[moduleIndex], apartmentArray[apartmentIndex]);
		sizeZ = Math.max(sizeZ, z);
		total = method === "Area" ? sizeX * sizeZ : sizeX;
		moduleIndex++;
		if (moduleIndex >= currentModules.length) {
			moduleIndex = 0;
			apartmentIndex++;
		}
	}
	if (!isInRange(sizeX * sizeZ, space.area[0], space.area[1])) return {
		success: false,
		outOfBounds: "Area"
	};
	if (!isInRange(sizeX, space.sizeX[0], space.sizeX[1])) return {
		success: false,
		outOfBounds: "SizeX"
	};
	if (sizeY < space.sizeY[0]) return {
		success: false,
		outOfBounds: "SizeY"
	};
	if (sizeY > space.sizeY[1]) return {
		success: false,
		outOfBounds: "SizeY"
	};
	if (sizeZ < space.sizeZ[0]) return {
		success: false,
		outOfBounds: "SizeZ"
	};
	if (sizeZ > space.sizeZ[1]) return {
		success: false,
		outOfBounds: "SizeZ"
	};
	return {
		success: true,
		unusedArea: total - space.area[0],
		newPos: {
			apartmentIndex,
			moduleIndex
		}
	};
}
export { tryInsertionMethod };

//# sourceMappingURL=index107.js.map